import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { onCheckBoxChange } from "utils/propertyChangeAdapters";
import { Grid, Divider, FormControlLabel, Checkbox, Typography } from "@mui/material";
import { Button, TextField } from "@totalsoft/rocket-ui";

const ConsentList = ({
  consents,
  partnerId,
  saveConsents,
  onConsentPropertyChange,
  saveDisabled,
  hasWritePermission
}) => {
  const { t } = useTranslation();

  return (
    <Grid container spacing={0} alignItems="flex-start" justifyContent="flex-end" direction="row">
      {consents.map((item, idx) => {
        return (
          <Grid key={item.consentTypeId} item xs={12} sm={12} md={12}>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6} md={3}>
                <FormControlLabel
                  control={
                    <Checkbox
                      id={"consent_selected_" + idx}
                      checked={item.selected || false}
                      onChange={onCheckBoxChange(onConsentPropertyChange(idx)("selected"))}
                      disabled={!hasWritePermission}
                    />
                  }
                  label={item.name}
                />
              </Grid>
              {
                <Grid item xs={12} sm={6} md={3}>
                  {t("Consent.AssignedBy")} :{" "}
                  <Typography fontWeight="bold">
                    {item.assignedByName}/{t("DATE", { date: item.assignedDate })}
                  </Typography>
                </Grid>
              }
              {
                <Grid item xs={12} sm={6} md={3}>
                  {t("Consent.ValidUntil")} :{" "}
                  <Typography fontWeight="bold">{t("DATE", { date: item.validUntil })}</Typography>
                </Grid>
              }
              {
                <Grid item xs={12} sm={6} md={3}>
                  {t("Consent.UnassignedBy")} :{" "}
                  <Typography fontWeight="bold">
                    {item.unassignedByName}/{t("DATE", { date: item.unassignedDate })}
                  </Typography>
                </Grid>
              }
              <Grid item xs={12} sm={8} md={9}>
                <TextField
                  id={"consent_comments_" + idx}
                  label={t("Consent.Comments")}
                  multiline
                  fullWidth
                  rows="2"
                  value={item.comments || ""}
                  onChange={onConsentPropertyChange(idx)("comments")}
                  disabled={!hasWritePermission}
                  inputProps={{
                    maxLength: 4000
                  }}
                />
              </Grid>
            </Grid>
            <Divider />
          </Grid>
        );
      })}
      <Button
        id="consent_btnSave"
        variant="contained"
        color="primary"
        onClick={() => saveConsents(partnerId, consents)}
        disabled={!hasWritePermission || saveDisabled}
        sx={{ marginTop: "1rem" }}
      >
        {t("Save")}
      </Button>
    </Grid>
  );
};

ConsentList.propTypes = {
  consents: PropTypes.array.isRequired,
  partnerId: PropTypes.number,
  saveConsents: PropTypes.func.isRequired,
  onConsentPropertyChange: PropTypes.func.isRequired,
  saveDisabled: PropTypes.bool,
  hasWritePermission: PropTypes.bool.isRequired
};

export default ConsentList;
